module.exports = __webpack_public_path__ + "img/block_1.18681789.png";